import { createContext, useContext, useState } from "react";
import { useAuth } from "./AuthContext";

const ViewRoleContext = createContext(null);

export function ViewRoleProvider({ children }) {
  const { user } = useAuth();
  const [viewAs, setViewAs] = useState("admin");

  // Un commercial ne peut jamais voir la vue admin.
  const effectiveRole = user?.role === "admin" ? viewAs : "commercial";
  const canSeeMargins = effectiveRole === "admin";
  const isAdmin = user?.role === "admin";

  return (
    <ViewRoleContext.Provider value={{ viewAs, setViewAs, effectiveRole, canSeeMargins, isAdmin }}>
      {children}
    </ViewRoleContext.Provider>
  );
}

export const useViewRole = () => useContext(ViewRoleContext);
